export const ZOOM_LEVEL_LOCAL_STORAGE_KEY = 'zoomLevel';
export const HOME_PAGE_TYPE_LOCAL_STORAGE_KEY = 'homePageType';
export const SELECTED_MARKET_LOCAL_STORAGE_KEY = 'selectedMarket';
export const HeaderThemeConfigStorageKey = 'SELECTED_HEADER_THEME';
export const HeaderThemeNameStorageKey = 'SELECTED_HEADER_THEME_NAME';

export const ZoomLevels = {
  small: 0.7,
  medium: 0.8,
  large: 1
};

export const ZoomLevelDisplayString = {
  [ZoomLevels.small]: 'Large',
  [ZoomLevels.medium]: 'Medium',
  [ZoomLevels.large]: 'Large'
};

export const MParticleEventCategory = 'Appearance';
export const MParticleEventName = 'InPlatform';
export const MParticleEventAction = 'Click';
export const MParticleEventLabels = {
  THEME: 'Appearance theme',
  MODE: 'Appearance mode',
  HOME_PAGE: 'Appearance default homepage',
  FONT_SIZE: 'Appearance font size'
};
